<template>
  <div>
    <div class="small-middle-banners">
      <div v-for="(banner, index) in banners" :key="index">
        <a
          v-if="banner.length > 1"
          :href="banner[rand].link"
          rel="nofollow"
          target="_blank"
        >
          <img
            :src="'https://www.eastguys.net/' + banner[rand].img"
            :alt="banner[rand].name"
          />
          <p>{{ banner[rand].name }}</p>
        </a>
        <a v-else :href="banner[0].link" rel="nofollow" target="_blank">
          <img
            :src="'https://www.eastguys.net/' + banner[0].img"
            :alt="banner[0].name"
          />
          <p>{{ banner[0].name }}</p>
        </a>
      </div>
    </div>

    <!-- <div class="banners-flex">
      <a href="https://www.cuteguys.net/" target="_blank" rel="nofollow"
        ><img
          src="https://www.eastguys.net/banners/new/cute9.jpg"
          alt="cuteguys.net"
          class="banner__ad"
      /></a>

      <a href="https://www.guysonfire.com/" target="_blank" rel="nofollow"
        ><img
          src="https://www.eastguys.net/banners/new/gof9.jpg"
          alt="cuteguys.net"
          class="banner__ad"
      /></a>

      <a
        href="https://www.malevision.net/steve-dehler-shows-his-cock.html"
        target="_blank"
        rel="nofollow"
        ><img
          src="https://www.eastguys.net/banners/new/mvis9.jpg"
          alt="cuteguys.net"
          class="banner__ad"
      /></a>
    </div> -->
  </div>
</template>


<script>
let middleCute = [
  [
    {
      name: "Csaba Szigeti",
      link: "https://www.cuteguys.net/csaba-szigeti/",
      img: "banners/new/middle-cute/csaba-szigeti.jpg",
    },
    {
      name: "Jeff Seid",
      link: "https://www.cuteguys.net/jeff-seid-bodybuilder-from-us/",
      img: "banners/new/middle-cute/jeff-seid-bodybuilder-from-us.jpg",
    },
    {
      name: "Josh Giles",
      link: "https://www.cuteguys.net/josh-giles-us-athlete/",
      img: "banners/new/middle-cute/josh-giles-us-athlete.jpg",
    },
    {
      name: "Kenan",
      link: "https://www.cuteguys.net/male-model-kenan/",
      img: "banners/new/middle-cute/male-model-kenan.jpg",
    },
    {
      name: "Mikhail Timoshin",
      link: "https://www.cuteguys.net/mikhail-timoshin/",
      img: "banners/new/middle-cute/mikhail-timoshin.jpg",
    },
    {
      name: "Swedish Men",
      link: "https://www.cuteguys.net/swedish-men-by-franz-fleissner/",
      img: "banners/new/middle-cute/swedish-men-by-franz-fleissner.jpg",
    },
  ],

  [
    {
      name: "Gay Webcam",
      link: "https://www.eastguys.net/out/gof",
      img: "banners/new/gof9.jpg",
    },
  ],

  [
    {
      name: "Alexander Dorokhov",
      link: "https://www.malevision.net/alexander-dorokhov.html",
      img: "banners/new/mv-middle/alexander-dorokhov.jpg",
    },
    {
      name: "Chris Cuba",
      link: "https://www.malevision.net/muscle-male-model-chris-cuba.html",
      img: "banners/new/mv-middle/chris-cuba.jpg",
    },
    {
      name: "Jeff Seid",
      link: "https://www.malevision.net/jeff-seid-stunning-model.html",
      img: "banners/new/mv-middle/jeff-seid.jpg",
    },
    {
      name: "Gay Books",
      link: "https://www.malevision.net/gay-erotic-photo-books.html",
      img: "banners/new/mv-middle/books.jpg",
    },
    {
      name: "Gay Books",
      link: "https://www.malevision.net/gay-erotic-photo-books.html",
      img: "banners/new/mv-middle/books1.jpg",
    },
    {
      name: "Gay Books",
      link: "https://www.malevision.net/gay-erotic-photo-books.html",
      img: "banners/new/mv-middle/books2.jpg",
    },
  ],
];

export default {
  data() {
    return {
      banners: [],
      rand: Math.floor(Math.random() * 6),
    };
  },
  methods: {
    getMiddle() {
      this.banners = middleCute;
    },
    randomNumber: function (id) {
      return Math.floor(Math.random() * id);
    },
    getR() {
      this.rand = Math.floor(Math.random() * 6);
    },
  },
  created() {
    this.getMiddle();
  },
  watch: {
    $route() {
      this.getR();
    },
  },
};
</script>